import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EntradasService } from 'src/app/services/datos/entradas.service';

@Component({
  selector: 'app-panel-entradas',
  templateUrl: './panel-entradas.component.html',
  styleUrls: ['./panel-entradas.component.scss']
})

export class PanelEntradasComponent implements OnInit {
  entradasTotales: any = null;

  constructor(
    private entradasSrv: EntradasService,
    private router: Router,) { }

  ngOnInit(): void {

    this.cargaEntradasTotales();
  }

  // Cargar datos de entradas totales
  cargaEntradasTotales() {
    this.entradasTotales = { entradasPendientes: [] };
    this.entradasSrv.entradasTotales().subscribe((resp) => {
      this.entradasTotales = resp.data;
      this.entradasTotales.entradasPendientes = resp.totales.entradasPendientes;

      console.log('__cargaEntradasTotales() ', this.entradasTotales);
    });
  }
}